import * as Utils from '../utils/util';
import * as CubeTree from '../cubeTree/index';
import { __dataSet__ } from './db';
import { getValue, hasKey } from './get';

export function setValue(cubeId: string, updateTask: FreeObjMap): void {
    let cube: CubeNode = CubeTree.findByCubeId(cubeId);

    for (let key in updateTask) {
        if (!hasKey(cubeId, key)) {
            continue;
        }
        setSingleValue(cubeId, key, updateTask[key]);

        // todo: 兼容老版本，需要删除
        cube.frontCubeData[key] = updateTask[key];
    }
}

function setSingleValue(cubeId: string, key: string, value: any): void {
    if (Utils.isArray(value) || Utils.isObject(value)) {
        let old: string = JSON.stringify(getValue(cubeId, key));

        if (JSON.stringify(value) !== old) {
            __dataSet__(cubeId, key, value);
        }
        return;
    }

    __dataSet__(cubeId, key, value);
}
